import * as React from "react"

interface Props {
  paymentSourceOptions: PaymentSourceOption[]
  users: UserOption[]
}

interface PaymentSourceOption {
  label: string
  value: string
  user_id: string
  user_full_name: string
}

interface UserOption {
  label: string
  value: string
}

interface State {
  paymentSourceValue: string
  paymentMethod: string
  userId?: string
  reference?: string
  selectedPaymentSourceValue?: string
}

export default class AdminPaymentSourceInputs extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = { paymentMethod: "manual", paymentSourceValue: "manual" }
  }

  render() {
    const paymentMethod = this.state.paymentMethod

    return (
      <div className="form-grid-setup" data-role="payment-source-select">
        <div className="row gap-4 mt-4">
          <div className="grid grid-flow-col justify-start gap-inline-2 align-middle">
            <input
              data-role="manual-payment"
              type="radio"
              name="toggleSource"
              value="manual"
              onClick={this.togglePaymentMethod}
              defaultChecked={paymentMethod === "manual"}
            />
            <label>Manual Payment</label>
          </div>
          {this.props.paymentSourceOptions.length > 0 && (
            <div className="grid grid-flow-col justify-start gap-inline-2 align-middle">
              <input
                data-role="electronic-payment"
                type="radio"
                name="toggleSource"
                value="electronic"
                onClick={this.togglePaymentMethod}
                defaultChecked={paymentMethod === "electronic"}
              />
              <label>Electronic Payment</label>
            </div>
          )}
        </div>

        {paymentMethod === "electronic" && (
          <div className="row">
            <select
              id="charge_source_id"
              name="charge[source_id]"
              value={this.state.paymentSourceValue}
              defaultValue={this.state.selectedPaymentSourceValue}
              onChange={this.changePaymentSource}>
              <option value="" data-user-id="">
                Select One
              </option>
              {this.props.paymentSourceOptions.map(({ label, user_id, user_full_name, value }) => (
                <option key={value} data-user-id={user_id} value={value}>
                  {user_full_name}: {label}
                </option>
              ))}
            </select>
            {this.state.userId && <input type="hidden" name="charge[user_id]" value={this.state.userId} />}
          </div>
        )}
        {paymentMethod === "manual" && (
          <>
            <div className="row">
              <input type="hidden" name="charge[source_id]" value="manual" />
            </div>
            <div className="stack">
              <label className="label-styled"> Who makes the payment</label>
              <select id="charge_user_id" name="charge[user_id]" value={this.state.userId}>
                {this.props.users.map(({ label, value }) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </div>

            <div className="stack">
              <label className="label-styled"> Reference</label>
              <input
                type="text"
                data-role="manual-payment-reference"
                name="charge[reference]"
                autoComplete="off"
                placeholder="Check #, Reference #, Description etc."
              />
            </div>
            <div className="italic text-gray-700">Please note that reference will be visible to the passenger</div>
          </>
        )}
      </div>
    )
  }

  togglePaymentMethod = (e) => {
    this.setState({ paymentMethod: e.target.value })
  }

  changePaymentSource = (e) => {
    const sourceId = e.target.value
    const userId = e.target.selectedOptions[0].dataset.userId

    this.setState({
      paymentSourceValue: sourceId,
      userId: userId,
      reference: sourceId === "manual" ? this.state.reference : undefined,
    })
  }
}
